import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Star, Award } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function ContributorsWall() {
  const [contributors, setContributors] = useState([]);

  useEffect(() => {
    axios.get(`${API}/community/contributors`)
      .then(res => setContributors(res.data))
      .catch(() => {});
  }, []);

  if (contributors.length === 0) return null;

  const medals = ['bg-amber-400', 'bg-slate-300', 'bg-amber-600'];

  return (
    <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 sm:p-8 rounded-3xl border border-amber-200" data-testid="contributors-wall">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 bg-amber-400 rounded-xl flex items-center justify-center">
          <Award className="w-5 h-5 text-white" />
        </div>
        <div>
          <h3 className="text-lg font-black text-slate-900">תודה לתורמים שלנו</h3>
          <p className="text-xs text-slate-500">משתמשים ששיתפו חומרי לימוד</p>
        </div>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {contributors.map((c, i) => (
          <div
            key={c.name}
            className="flex items-center gap-2 bg-white px-3 py-2 rounded-xl border border-amber-100 shadow-sm hover:shadow-md transition-shadow"
            data-testid={`contributor-${i}`}
          >
            <div className={`w-6 h-6 ${i < 3 ? medals[i] : 'bg-amber-100'} rounded-full flex items-center justify-center flex-shrink-0`}>
              <Star className={`w-3.5 h-3.5 ${i < 3 ? 'text-white' : 'text-amber-500'}`} />
            </div>
            <span className="font-bold text-sm text-slate-800">{c.name}</span>
            <span className="text-xs text-amber-600 font-bold bg-amber-50 px-1.5 py-0.5 rounded-full">
              {c.count} {c.count === 1 ? 'שיתוף' : 'שיתופים'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContributorsWall;
